import { BLOGS_API } from 'modules/blogs/api/blog-api'
import {
  BlogPostsApiInterface,
  BlogPostsFilterInterface,
} from 'modules/blogs/types/blog-posts-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

interface UseBlogPostsInterface extends SwrPaginationInterface {
  id: string
  filter: BlogPostsFilterInterface
}

export function useBlogPosts({ id, pagination, limit, filter }: UseBlogPostsInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, BlogPostsApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${
    filter.searchBy !== '' ? `&filter[searchBy]=${encodeURIComponent(filter.searchBy)}` : ''
  }${filter.isActive !== undefined ? `&filter[isActive]=${filter.isActive}` : ''}`

  const { data: blogPosts, mutate: blogPostsMutate } = useSWR(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${BLOGS_API}/${id}/posts/list?pagination[limit]=${limit}${filterApi}`
    } else if (user && pagination.startFromId && limit) {
      return `${BLOGS_API}/${id}/posts/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`
    }
    return null
  }, fetcher)

  const { data: blogPostsCounter } = useSWR<CountInterface>(() => {
    if (user) {
      return `${BLOGS_API}/${id}/posts/count?pagination[limit]${filterApi}`
    }
    return null
  }, baseFetcher)

  return {
    blogPosts,
    blogPostsMutate,
    blogPostsCounter,
  }
}
